import type { DataSource, Entity, SatelliteEntity } from '../types/entity';
import { apiFetch } from '../lib/apiFetch';

/**
 * Client nunca fala com a N2YO diretamente — sempre via proxy
 * `/api/n2yo`. Ver functions/src/proxies/n2yo.ts.
 */

interface N2yoProxySatellite {
  noradId: number;
  name: string;
  lat: number;
  lon: number;
  altitudeKm: number;
}

interface N2yoProxyResponse {
  satellites: N2yoProxySatellite[];
}

function toSatelliteEntity(s: N2yoProxySatellite): SatelliteEntity {
  return {
    id: `satellite-${s.noradId}`,
    layer: 'satellites',
    lat: s.lat,
    lon: s.lon,
    label: s.name,
    severity: 'normal',
    observedAt: new Date().toISOString(),
    raw: {
      noradId: s.noradId,
      altitudeKm: s.altitudeKm,
      velocityKmS: 0, // endpoint "above" da N2YO não retorna velocidade
    },
  };
}

export const satellitesSource: DataSource = {
  layer: 'satellites',
  label: 'Satélites (N2YO)',
  requiresClientKey: false,
  viaCloudFunction: true,

  async fetchEntities(): Promise<Entity[]> {
    const res = await apiFetch('/n2yo');
    if (!res.ok) {
      throw new Error(`Proxy N2YO respondeu ${res.status}`);
    }

    const data = (await res.json()) as N2yoProxyResponse;
    return data.satellites.map(toSatelliteEntity);
  },
};
